import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Loader2, Rocket, Copy } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { funnelSid, track } from "@/lib/funnel";
import { copyText } from "@/lib/clipboard";

/** جرّب بلا تسجيل: اسم المشروع + نوعه → نص منشور وأفكار حملات فورًا (نص فقط) ثم دعوة للتسجيل للصور والفيديو */
export const TryNow = () => {
  const [name, setName] = useState("");
  const [biz, setBiz] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const go = async (e) => {
    e.preventDefault();
    if (name.trim().length < 2 || biz.trim().length < 2) return toast.error("اكتب اسم مشروعك ونوع نشاطه");
    setBusy(true);
    track("try_start");
    try {
      const { data } = await api.post("/public/try", { name: name.trim(), business_type: biz.trim(), sid: funnelSid() });
      setRes(data);
      track("try_result");
      track("try_cta_shown");
    } catch (err) { toast.error(formatError(err?.response?.data?.detail) || "تعذّرت التجربة الآن"); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-3xl border border-primary/30 bg-card/80 backdrop-blur p-5 sm:p-6 shadow-lg" data-testid="try-now">
      <div className="flex items-center gap-2 mb-1"><Sparkles className="w-5 h-5 text-primary" /><h3 className="font-bold text-base md:text-lg">جرّب الآن بدون تسجيل</h3></div>
      <p className="text-sm text-muted-foreground mb-4">اكتب اسم مشروعك ونوعه، وشوف بنفسك نص منشور وأفكار حملات باللهجة السعودية خلال ثوانٍ.</p>
      {!res ? (
        <form onSubmit={go} className="grid sm:grid-cols-[1fr_1fr_auto] gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="اسم مشروعك (مثال: مقهى دندنة)" maxLength={60} className="bg-secondary border-border h-11" data-testid="try-name" />
          <Input value={biz} onChange={(e) => setBiz(e.target.value)} placeholder="نوع النشاط (مثال: قهوة مختصة)" maxLength={80} className="bg-secondary border-border h-11" data-testid="try-biz" />
          <Button type="submit" disabled={busy} className="h-11 gap-2 font-bold" data-testid="try-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} جرّب مجانًا
          </Button>
        </form>
      ) : (
        <div className="space-y-3" data-testid="try-result">
          <div className="rounded-2xl bg-secondary/70 border border-border p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-bold text-primary">نص منشور جاهز</span>
              <button type="button" onClick={async () => { (await copyText(res.caption)) ? toast.success("تم النسخ") : toast.error("تعذّر النسخ"); }} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="try-copy"><Copy className="w-3.5 h-3.5" /> نسخ</button>
            </div>
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{res.caption}</p>
          </div>
          {res.hook && <div className="text-sm"><span className="font-bold text-primary">افتتاحية فيديو: </span>{res.hook}</div>}
          {res.ideas?.length > 0 && (
            <ul className="space-y-1.5">
              {res.ideas.map((x, i) => <li key={i} className="text-sm flex gap-2"><span className="text-primary font-bold">{i + 1}.</span><span>{x}</span></li>)}
            </ul>
          )}
          <div className="rounded-2xl bg-primary/10 border border-primary/30 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
            <p className="text-sm flex-1"><span className="font-bold">هذا جزء بسيط.</span> سجّل مجانًا وخلّ المنصة تنتج لك الصور والفيديو والاستراتيجية الكاملة لمشروع «{name}».</p>
            <Link to={`/register?track=content&name=${encodeURIComponent(name)}&biz=${encodeURIComponent(biz)}`} onClick={() => track("cta_click", "try")}>
              <Button className="gap-2 font-bold h-11 w-full sm:w-auto" data-testid="try-register-cta"><Rocket className="w-4 h-4" /> سجّل واحصل على الصور والفيديو مجانًا</Button>
            </Link>
          </div>
          <button type="button" onClick={() => setRes(null)} className="text-xs text-muted-foreground hover:text-foreground" data-testid="try-again">جرّب مشروعًا آخر</button>
        </div>
      )}
    </div>
  );
};
